import React from 'react';
import { MapPin, Phone, Instagram, Mail } from 'lucide-react';
import { shopInfo } from '../mock';

const Contact = () => {
  return (
    <section id="contact" className="relative bg-[#0f0d0a] py-28 md:py-36 border-t border-[#c9a961]/10">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-stretch">
        <div className="reveal">
          <div className="flex items-center gap-3 mb-5">
            <div className="h-px w-10 bg-[#c9a961]" />
            <span className="text-[#c9a961] tracking-[0.35em] text-xs uppercase">Contact</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#f5efe4] leading-tight">
            Nous <em className="text-[#c9a961]">rendre visite</em>.
          </h2>
          <p className="mt-6 text-[#c8beab] text-[15px] leading-relaxed max-w-lg">
            Situé au cœur de Ramonville, le salon bénéficie d’un stationnement facile
            à proximité. Passez nous voir ou contactez-nous pour toute question.
          </p>

          <div className="mt-10 space-y-6">
            <Item icon={MapPin} label="Adresse">
              {shopInfo.address}
            </Item>
            <Item icon={Phone} label="Téléphone">
              <a href={`tel:${shopInfo.phone.replace(/\s/g, '')}`} className="link-gold">
                {shopInfo.phone}
              </a>
              <div className="text-xs text-[#a8a29e] mt-1">Prise de rendez-vous par appel direct</div>
            </Item>
            <Item icon={Instagram} label="Instagram">
              <a href={shopInfo.instagramUrl} target="_blank" rel="noreferrer" className="link-gold">
                @{shopInfo.instagram}
              </a>
              <div className="text-xs text-[#a8a29e] mt-1">Prise de rendez-vous par message</div>
            </Item>
            <Item icon={Mail} label="Email">
              <a href="mailto:contact@jrbarber.fr" className="link-gold">
                contact@jrbarber.fr
              </a>
            </Item>
          </div>
        </div>

        <div className="reveal relative min-h-[420px] border border-[#c9a961]/20 overflow-hidden">
          <iframe
            title="Carte JR Barber"
            src="https://www.google.com/maps?q=271+Route+de+Narbonne,+31400+Toulouse&output=embed"
            className="w-full h-full min-h-[420px] grayscale"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

const Item = ({ icon: Icon, label, children }) => (
  <div className="flex gap-5 items-start">
    <div className="w-12 h-12 shrink-0 border border-[#c9a961]/40 flex items-center justify-center">
      <Icon className="w-5 h-5 text-[#c9a961]" />
    </div>
    <div>
      <div className="text-[10px] uppercase tracking-[0.3em] text-[#a8a29e] mb-1">{label}</div>
      <div className="text-[#f5efe4] text-lg font-medium">{children}</div>
    </div>
  </div>
);

export default Contact;
